import type { AppState } from "../types";
import { calendarRange, formatMonth, monthKey, shiftMonth, todayInJapan, toUtcDate } from "../lib/date";
import { ChevronIcon } from "./Icons";

interface CalendarViewProps {
  month: string;
  selectedDate: string;
  state: AppState;
  onMonthChange: (month: string) => void;
  onDateSelect: (date: string) => void;
}

const WEEK_LABELS = ["日", "月", "火", "水", "木", "金", "土"];

export function CalendarView({ month, selectedDate, state, onMonthChange, onDateSelect }: CalendarViewProps) {
  const range = calendarRange(month);
  const today = todayInJapan();
  const activeTaskCount = state.tasks.filter((task) => task.is_active).length;

  return (
    <section className="calendar-card" aria-label="掃除カレンダー">
      <div className="calendar-toolbar">
        <button className="icon-button" aria-label="前の月" onClick={() => onMonthChange(shiftMonth(month, -1))}>
          <ChevronIcon direction="left" />
        </button>
        <h2>{formatMonth(month)}</h2>
        <button className="icon-button" aria-label="次の月" onClick={() => onMonthChange(shiftMonth(month, 1))}>
          <ChevronIcon />
        </button>
      </div>
      <div className="weekday-grid" aria-hidden="true">
        {WEEK_LABELS.map((label) => <span key={label}>{label}</span>)}
      </div>
      <div className="calendar-grid">
        {range.days.map((date) => {
          const count = state.records.filter((record) => record.record_date === date).length;
          const outside = monthKey(date) !== month;
          const weekday = toUtcDate(date).getUTCDay();
          return (
            <button
              key={date}
              className={[
                "calendar-day",
                outside ? "is-outside" : "",
                date === today ? "is-today" : "",
                date === selectedDate ? "is-selected" : "",
                weekday === 0 ? "is-sunday" : "",
                weekday === 6 ? "is-saturday" : "",
              ].filter(Boolean).join(" ")}
              aria-label={`${date}、${count}件完了`}
              onClick={() => onDateSelect(date)}
            >
              <span>{Number(date.slice(8, 10))}</span>
              {count > 0 && (
                <span className={`calendar-count ${activeTaskCount > 0 && count >= activeTaskCount ? "is-all-done" : ""}`}>
                  {count}
                </span>
              )}
            </button>
          );
        })}
      </div>
      <button className="text-button today-jump" onClick={() => onDateSelect(today)}>今日に戻る</button>
    </section>
  );
}
